import axios from "../axios";

// 分页查询
export const list = (data) => {
    return axios({
        url: '/mSmsNotification/list',
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        noSerializeData: true,//不序列化参数
        data
    })
}
// 发送
export const sender = (data) => {
    return axios({
        url: '/mSmsNotification/sender',
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        noSerializeData: true,//不序列化参数
        data
    })
}

export const findMsgContent = (data, param) => {
    return axios({
        url: '/mSmsNotification/findMsgContent',
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        noSerializeData: true,//不序列化参数
        data,
        params: param
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/smsNotification.js